import {createEvent, type Emitter, type Listener} from "react-event-hook";

// This file manages event handling for exercise question answerable state.
// It exports functions dedicated to listening for and emitting events pertaining
// to exercise questions answerable state.
export interface ExerciseQuestionAnswerableStateChangedPayload {
    taskType: string;
    answerable: boolean;
}

interface Event {
    useExerciseQuestionAnswerableStateChangedListener: Listener<ExerciseQuestionAnswerableStateChangedPayload>;
    emitExerciseQuestionAnswerableStateChanged: Emitter<ExerciseQuestionAnswerableStateChangedPayload>;
}

export const {
    useExerciseQuestionAnswerableStateChangedListener,
    emitExerciseQuestionAnswerableStateChanged,
} = createEvent("exercise-question-answerable-state-changed")() as Event;
